// import React from "react";
// import { Link } from "react-router-dom";
// import { MdCall } from "react-icons/md";
// import { GrMail } from "react-icons/gr";
// import { HiLocationMarker } from "react-icons/hi";
// import { BsFillSuitHeartFill } from "react-icons/bs";
// import instaLogo from "../../assets/img/instagram.png";
// import whatsapp from '../../assets/img/WhatsApp_icon.png';
// import facebook from '../../assets/img/facebook.png';
// import youtube from '../../assets/img/youtube.png';
// import Logo from '../../assets/img/Threads.png';
// import Fssai from '../../assets/img/fssai-removebg-preview.png';
// import Msme from '../../assets/img/msme-removebg-preview.png';
// const Footer = () => {
//   return (
//     <>
//       <footer
//         // style={{ backgroundColor: "rgb(254, 184, 109)" }}
//         // style={{backgroundColor:"#F5D061"}}
//         style={{ backgroundColor: "#F1E4C3" }}
//         id="tempaltemo_footer"
//       >
//         <div className="container">
//           <div className="row">
//             <div className="col-md-4 pt-5">
//               <h2 className="h3 text-success border-bottom pb-3 border-light logo">
//                 Sri Mangalambika store
//               </h2>
//               <ul className="list-unstyled text-black footer-link-list">
//                 <li>
//                   <HiLocationMarker className="me-2 mb-1 text-black" />
//                   no 7 kumbeshwarar south street
//                   <br />
//                   Thanjavur main road kumbakonam-612 001.
//                 </li>
//                 <li>
//                   <MdCall className="me-2 mb-1" />
//                   <a
//                     className="text-decoration-none text-black"
//                     href="tel: 9123582481"
//                   >
//                     9363700957 , 9123582481
//                   </a>
//                 </li>
//                 <li>
//                   <GrMail className="me-2 mb-1" />
//                   <a
//                     className="text-decoration-none text-black"
//                     href="mailto:mangla@gmail.com"
//                   >
//                     mangalambikai@gmail.com
//                   </a>
//                 </li>

//                 <li>
//                   <a
//                     className="text-decoration-none text-white"
//                     href="https://www.instagram.com/chakra_art_and_craft/?igsh=MWJjNG13bjU0b2wxOQ%3D%3D#"
//                     target="blank"
//                   >
//                     <img
//                       src={instaLogo}
//                       height="30px"
//                       width="auto"
//                       className="me-1 mt-0"
//                       alt="Sri Mangalambika store instagram"
//                     />
//                   </a>
//                   &nbsp;&nbsp;&nbsp;&nbsp;
//                   <a
//                     className="text-decoration-none"
//                     href="https://api.whatsapp.com/916369126300"
//                     target="blank"
//                   >
//                     <img
//                       src={whatsapp}
//                       height="35px"
//                       width="auto"
//                       className="me-1 mt-0"
//                       alt="Sri Mangalambika store whatsapp"
//                     />
//                   </a>
//                   &nbsp;&nbsp;&nbsp;&nbsp;
//                   <a
//                     className="text-decoration-none"
//                     href="https://www.facebook.com/"
//                     target="blank"
//                   >
//                     <img
//                       src={facebook}
//                       height="35px"
//                       width="auto"
//                       className="me-1 mt-0"
//                       alt="Sri Mangalambika store facebook"
//                     />
//                   </a>
//                   &nbsp;&nbsp;&nbsp;&nbsp;
//                   <a
//                     className="text-decoration-none"
//                     href="https://www.youtube.com/"
//                     target="blank"
//                   >
//                     <img
//                       src={youtube}
//                       height="35px"
//                       width="auto"
//                       className="me-1 mt-0"
//                       alt="Sri Mangalambika store youtube"
//                     />
//                   </a>
//                   &nbsp;&nbsp;&nbsp;&nbsp;
//                   <a
//                     className="text-decoration-none"
//                     href="https://www.threads.net/"
//                     target="blank"
//                   >
//                     <img
//                       src={Logo}
//                       height="30px"
//                       width="auto"
//                       className="me-1 mt-0"
//                       alt="Sri Mangalambika store youtube"
//                     />
//                   </a>
//                 </li>
//               </ul>
//             </div>

//             <div className="col-md-4 pt-5">
//               <h2 className="h2 text-black border-bottom pb-3 border-light">
//                 Products
//               </h2>
//               <ul className="list-unstyled text-light footer-link-list">
//                 <li>
//                   <Link
//                     className="text-decoration-none text-black"
//                     to="/herbalProduct"
//                   >
//                     Iron and cast iron
//                   </Link>
//                 </li>
//                 <li>
//                   <Link
//                     className="text-decoration-none text-black"
//                     to="/gardenProduct"
//                   >
//                     Brass and bronze
//                   </Link>
//                 </li>
//                 <li>
//                   <Link
//                     className="text-decoration-none text-black"
//                     to="/yogaProduct"
//                   >
//                     wooden and toys
//                   </Link>
//                 </li>
//                 <li>
//                   <Link
//                     className="text-decoration-none text-black"
//                     to="/foodProduct"
//                   >
//                     others
//                   </Link>
//                 </li>
                
//                 <li>
//                   <img
//                     src={Fssai}
//                     height="40px"
//                     width="auto"
//                     className="me-1 mt-0"
//                     alt="Sri Mangalambika store youtube"
//                   />
//                 </li>
//                 <li>
//                   <img
//                     src={Msme}
//                     height="35px"
//                     width="auto"
//                     className="me-1 mt-0"
//                     alt="Sri Mangalambika store youtube"
//                   />
//                 </li>
//               </ul>
//             </div>

//             <div className="col-md-4 pt-5">
//               <h2 className="h2 text-black border-bottom pb-3 border-light">
//                 Further Info
//               </h2>
//               <ul className="list-unstyled text-light footer-link-list">
//                 <li>
//                   <Link className="text-decoration-none text-black" to="/">
//                     Home
//                   </Link>
//                 </li>
//                 <li>
//                   <Link className="text-decoration-none text-black" to="/about">
//                     About Us
//                   </Link>
//                 </li>
//                 <li>
//                   <Link
//                     className="text-decoration-none text-black"
//                     to="/policy"
//                   >
//                     Privacy Policy
//                   </Link>
//                 </li>
//                 <li>
//                   <Link className="text-decoration-none text-black" to="/terms">
//                     Terms and Conditions
//                   </Link>
//                 </li>
//               </ul>
//             </div>
//           </div>
//         </div>

//         <div className="w-100 bg-black py-3">
//           <div className="container">
//             <div className="row pt-2">
//               <div className="d-flex justify-content-between col-12">
//                 <p className="text-left text-light">
//                   Copyright &copy; 2025 Sri Mangalambika store
//                 </p>
//                 <a
//                   href="https://vebbox.com/"
//                   className="text-decoration-none text-light"
//                 >
//                   Developed by vebbox software solutions with passion
//                   <BsFillSuitHeartFill
//                     className="ms-1"
//                     style={{ color: "#c0392b", marginTop: "-5px" }}
//                   />
//                 </a>
//               </div>
//             </div>
//           </div>
//         </div>
//       </footer>
//     </>
//   );
// };
// export default Footer;

import React from "react";
import { Link } from "react-router-dom";
import { MdCall } from "react-icons/md";
import { GrMail } from "react-icons/gr";
import { HiLocationMarker } from "react-icons/hi";
import { BsFillSuitHeartFill } from "react-icons/bs";

import instaLogo from "../../assets/img/instagram.png";
import whatsapp from "../../assets/img/WhatsApp_icon.png";
import facebook from "../../assets/img/facebook.png";
import youtube from "../../assets/img/youtube.png";
import Logo from "../../assets/img/Threads.png";
import Fssai from "../../assets/img/fssai-removebg-preview.png";
import Msme from "../../assets/img/msme-removebg-preview.png";

const Footer = () => {
  return (
    <footer style={{ backgroundColor: "#FF9C73" }} id="tempaltemo_footer">
      <div className="container py-5">
        <div className="row gy-4">
          {/* Contact Section */}
          <div className="col-12 col-md-4">
            <h2 className="h5 border-bottom pb-2 mb-3 border-light">
              Jannu's Food Products
            </h2>
            <ul className="list-unstyled text-black">
              <li className="mb-2">
                <HiLocationMarker className="me-2" />
                No 7 Kumbeshwarar South Street,
                <br />
                Thanjavur Main Road, Kumbakonam - 612001
              </li>
              <li className="mb-2">
                <MdCall className="me-2" />
                <a
                  className="text-black text-decoration-none"
                  href="tel:9363700957"
                >
                  9363678950, 9333582351
                </a>
              </li>
              <li className="mb-3">
                <GrMail className="me-2" />
                <a
                  className="text-black text-decoration-none"
                  href="mailto:jannu@gmail.com"
                >
                  jannu@gmail.com
                </a>
              </li>
              {/* Social Icons */}
              <li className="d-flex flex-wrap gap-3">
                <a
                  href="https://www.instagram.com/chakra_art_and_craft/?igsh=MWJjNG13bjU0b2wxOQ%3D%3D"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={instaLogo} height="30" alt="Instagram" />
                </a>
                <a
                  href="https://api.whatsapp.com/916369126300"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={whatsapp} height="35" alt="WhatsApp" />
                </a>
                <a
                  href="https://www.facebook.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={facebook} height="35" alt="Facebook" />
                </a>
                <a
                  href="https://www.youtube.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={youtube} height="35" alt="YouTube" />
                </a>
                <a
                  href="https://www.threads.net/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={Logo} height="30" alt="Threads" />
                </a>
              </li>
            </ul>
          </div>

          {/* Products Section */}
          <div className="col-12 col-md-4">
            <h2 className="h4 text-black border-bottom border-light pb-2 mb-3">
              Products
            </h2>
            <ul className="list-unstyled text-black">
              <li className="mb-2">
                <Link
                  className="text-decoration-none text-black"
                  to="/herbalProduct"
                >
                  healthy mix
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  className="text-decoration-none text-black"
                  to="/gardenProduct"
                >
                  Weight Loss
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  className="text-decoration-none text-black"
                  to="/yogaProduct"
                >
                  Weight Gain
                </Link>
              </li>
              <li className="mb-3">
                <Link
                  className="text-decoration-none text-black"
                  to="/foodProduct"
                >
                  Others
                </Link>
              </li>
              <li className="mb-2">
                <img src={Fssai} height="40" alt="FSSAI" />
              </li>
              <li>
                <img src={Msme} height="35" alt="MSME" />
              </li>
            </ul>
          </div>

          {/* Further Info Section */}
          <div className="col-12 col-md-4">
            <h2 className="h4 text-black border-bottom pb-2 mb-3 border-light">
              Further Info
            </h2>
            <ul className="list-unstyled text-black">
              <li className="mb-2">
                <Link className="text-decoration-none text-black" to="/">
                  Home
                </Link>
              </li>
              <li className="mb-2">
                <Link className="text-decoration-none text-black" to="/about">
                  About Us
                </Link>
              </li>
              <li className="mb-2">
                <Link className="text-decoration-none text-black" to="/policy">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link className="text-decoration-none text-black" to="/terms">
                  Terms and Conditions
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="w-100 bg-black text-light py-3">
        <div className="container d-flex flex-column flex-md-row justify-content-between align-items-center">
          <p className="mb-2 mb-md-0">
            &copy; 2025 jannu's Food Products. All rights reserved.
          </p>
          <a
            href="https://vebbox.com/"
            className="text-decoration-none text-light d-flex align-items-center"
          >
            Developed by Vebbox Software Solutions with passion
            <BsFillSuitHeartFill
              className="ms-2"
              style={{ color: "#c0392b" }}
            />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

